// extracted by mini-css-extract-plugin
module.exports = {"container":"Superheroes_container__2iTSw","progress":"Superheroes_progress__3dR_P","textContainer":"Superheroes_textContainer__KQX7M","error":"Superheroes_error__1j4a9"};